import styled from 'react-emotion';

import BaseList from '@ublend-npm/aulaui-next-web/List';

export const FullWidthList = styled(BaseList)`
  display: flex;
  flex: 1;
  flex-direction: column;
  & > li {
    display: flex;
    flex: 1;
  }
`;

export const CompactList = styled(BaseList)`
  padding: 0px;
`;
